var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgMc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 4.83268C6.69935 4.83268 4.83268 6.69935 4.83268 8.99935C4.83268 11.2993 6.69935 13.166 8.99935 13.166C11.2993 13.166 13.166 11.2993 13.166 8.99935C13.166 6.69935 11.2993 4.83268 8.99935 4.83268ZM8.99935 0.666016C4.39935 0.666016 0.666016 4.39935 0.666016 8.99935C0.666016 13.5993 4.39935 17.3327 8.99935 17.3327C13.5993 17.3327 17.3327 13.5993 17.3327 8.99935C17.3327 4.39935 13.5993 0.666016 8.99935 0.666016ZM8.99935 15.666C5.31602 15.666 2.33268 12.6827 2.33268 8.99935C2.33268 5.31602 5.31602 2.33268 8.99935 2.33268C12.6827 2.33268 15.666 5.31602 15.666 8.99935C15.666 12.6827 12.6827 15.666 8.99935 15.666Z",
    fill: "#3C7EBF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMc);
export default __webpack_public_path__ + "static/media/mc.632b5c34655ee61a444c58145f08dc98.svg";
export { ForwardRef as ReactComponent };